import { mapGetters } from 'vuex';

export default {
    name: 'bankrateFooter',
    computed: {
        ...mapGetters('dpp', ['dpp']),
        ...mapGetters('glb', ['glb']),
    },
};
